module.exports = __webpack_public_path__ + "static/img/12.5a7c995.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/12.png
// module id = xsCj
// module chunks = 1